module.exports = __webpack_public_path__ + "static/mw13-591e189dc2c4ea7f1fc95e78a63b5939.jpg";